if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          copyButton: this.querySelector('.share-button__copy'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.fallbackInitialized = false;

        if (this.shouldUseNativeShare()) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', this.shareNative.bind(this));
        } else {
          this.enableFallbackShare();
        }
      }

      shouldUseNativeShare() {
        return (
          navigator.share &&
          window.matchMedia &&
          window.matchMedia('(pointer: coarse)').matches
        );
      }

      async shareNative() {
        try {
          await navigator.share({ url: this.urlToShare, title: document.title });
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          this.enableFallbackShare(true);
        }
      }

      enableFallbackShare(openDetails = false) {
        if (this.elements.shareButton) this.elements.shareButton.classList.add('hidden');
        if (this.mainDetailsToggle) this.mainDetailsToggle.removeAttribute('hidden');

        if (!this.fallbackInitialized && this.mainDetailsToggle) {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          if (this.elements.copyButton) {
            this.elements.copyButton.addEventListener('mousedown', (event) => event.preventDefault());
            this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
          }
          if (this.elements.closeButton) {
            this.elements.closeButton.addEventListener('click', this.close.bind(this));
          }
          this.fallbackInitialized = true;
        }

        if (openDetails && this.mainDetailsToggle) {
          this.mainDetailsToggle.open = true;
          if (this.elements.urlInput) {
            this.elements.urlInput.focus();
            this.elements.urlInput.select();
          }
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        const shareUrl = this.elements.urlInput.value;
        if (this.mainDetailsToggle) this.mainDetailsToggle.open = true;

        if (!navigator.clipboard) {
          this.copyToClipboardFallback();
          return;
        }

        navigator.clipboard
          .writeText(shareUrl)
          .then(() => this.showSuccessMessage())
          .catch(() => this.copyToClipboardFallback());
      }

      copyToClipboardFallback() {
        this.elements.urlInput.focus();
        this.elements.urlInput.select();
        document.execCommand('copy');
        this.showSuccessMessage();
      }

      showSuccessMessage() {
        if (this.mainDetailsToggle) this.mainDetailsToggle.open = true;
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.elements.closeButton.classList.remove('hidden');
        this.elements.closeButton.focus();
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
